/**
 * What cancelling a scrape request did about its credit (PREC-4456). The API answers it with the
 * cancel, and the web words its toast from it:
 * - REFUNDED: the charge was found and given back (`refundedCredits` says how much);
 * - NOT_CHARGED: nothing was charged for this request, so there was nothing to give back;
 * - CHARGE_UNRESOLVED: a charge may exist but could not be matched to the request, so nothing
 *   was given back automatically. Support can look it up; the API logs it.
 */
export enum ScrapeRefundOutcome {
	REFUNDED = "REFUNDED",
	NOT_CHARGED = "NOT_CHARGED",
	CHARGE_UNRESOLVED = "CHARGE_UNRESOLVED",
}
